import { render } from "./EletronicaPage.vue?vue&type=template&id=0e249fbb&scoped=true"
import script from "./EletronicaPage.vue?vue&type=script&lang=js"
export * from "./EletronicaPage.vue?vue&type=script&lang=js"

import "./EletronicaPage.vue?vue&type=style&index=0&id=0e249fbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e249fbb"]])

export default __exports__